import React from 'react';
import { Box, Icon, IconButton } from '@chakra-ui/react';
import { AnimatePresence } from 'framer-motion';
import { FiChevronDown } from 'react-icons/fi';
import { MotionBox, scaleIn, useMotionPrefs, EASE } from './motion';

/**
 * The round "jump to latest" button that appears when the reader has scrolled
 * up, with a badge for messages that arrived meanwhile.
 *
 * A message arriving while someone is reading history must NOT yank the view
 * to the bottom — that is the single most annoying thing a chat can do. It
 * counts up here instead, and one click catches up.
 */
export default function JumpToLatest({ visible, count, onClick }) {
	const { dur } = useMotionPrefs();
	return (
		<AnimatePresence>
			{visible && (
				<MotionBox
					position="absolute"
					right="4"
					bottom="4"
					zIndex="2"
					initial={scaleIn.initial}
					animate={scaleIn.animate}
					exit={scaleIn.exit}
					transition={{ duration: dur(160), ease: EASE }}
				>
					<Box position="relative">
						<IconButton
							aria-label={count > 0 ? `${count} new messages, jump to latest` : 'Jump to latest'}
							icon={<Icon as={FiChevronDown} boxSize="5" />}
							borderRadius="full"
							size="md"
							bg="wa.datePill"
							color="wa.inkMuted"
							boxShadow="0 2px 6px rgba(0,0,0,0.25)"
							_hover={{ bg: 'wa.datePill', color: 'wa.ink' }}
							_active={{ transform: 'scale(0.94)' }}
							onClick={onClick}
						/>
						{count > 0 && (
							<Box
								position="absolute"
								top="-6px"
								right="-4px"
								minW="20px"
								h="20px"
								px="1.5"
								borderRadius="full"
								bg="wa.accent"
								color="wa.accentInk"
								fontSize="0.65rem"
								fontWeight="bold"
								display="flex"
								alignItems="center"
								justifyContent="center"
								aria-live="polite"
							>
								{count > 99 ? '99+' : count}
							</Box>
						)}
					</Box>
				</MotionBox>
			)}
		</AnimatePresence>
	);
}
